import { Icon } from "@artprov/design-system";

export const Loading = ({ show }) => {
  return (
    show && (
      <div className="flex-1 justify-center items-center flex">
        <Icon
          variant="loading"
          size="large"
          className="flex items-center justify-center"
          classNameIcon="text-[40px] leading-none flex items-center justify-center"
        />
      </div>
    )
  );
};
